<template>
  <span class="editor-info-wrapper">
    <span
      ref="targetRef"
      class="editor-info-icon-wrapper"
      :class="{ active: editing }"
      @mouseenter="showTooltip"
      @mouseleave="hideTooltip"
      @click="handleClick"
    >
      <SvgIcon name="editor/info" />
    </span>
    <EditorInfoIconContent
      v-show="editing || (text && (isShown || fixedShowed))"
      ref="tooltipRef"
      :editing="editing"
      :text="text"
      @change="handleChange"
      @delete="handleDelete"
      @input="handleInput"
    />
  </span>
</template>

<script setup>
const WINDOW_PADDING = 10;
const props = defineProps({
  editable: { type: Boolean, default: false },
  text: { type: [String, Number], default: '' },
});

const editing = ref(false);
const isShown = ref(false);
const fixedShowed = ref(false);
const targetRef = ref(null);
const tooltipRef = ref(null);

onMounted(() => {
  window.addEventListener('scroll', getPosition);
  window.addEventListener('resize', getPosition);
});

onUnmounted(() => {
  window.removeEventListener('scroll', getPosition);
  window.removeEventListener('resize', getPosition);
});

const handleInput = () => {
  getPosition();
};

const handleClick = () => {
  if (props.editable) {
    editing.value = !editing.value;
  } else {
    fixedShowed.value = !fixedShowed.value;
  }
  nextTick().then(() => getPosition());
};

const handleChange = (text) => {
  emit('change', text);
  editing.value = false;
  hideTooltip();
};

const handleDelete = () => {
  emit('delete');
};

const showTooltip = () => {
  isShown.value = true;
  nextTick().then(() => getPosition());
};

const hideTooltip = () => {
  if (editing.value) return;
  isShown.value = false;
};

const getPosition = () => {
  if (!targetRef.value || !tooltipRef.value.$el) return;
  const target = targetRef.value;
  const tooltip = tooltipRef.value.$el;

  // спозиционируем его сверху от аннотируемого элемента (top-center)
  const coords = target.getBoundingClientRect();
  let left = coords.left; /* + target.offsetWidth - tooltip.offsetWidth) / 2 */

  if (left < 0) left = WINDOW_PADDING; // не заезжать за левый край окна

  const top = coords.top + target.offsetHeight; /* + WINDOW_PADDING */
  const tooltipCoords = tooltip.getBoundingClientRect();

  if (coords.left + tooltip.offsetWidth + WINDOW_PADDING > window.innerWidth) {
    // не заезжать за правый край окна
    left = window.innerWidth - tooltip.offsetWidth - WINDOW_PADDING;
  }

  tooltip.style.left = left + 'px';
  tooltip.style.top = top + 'px';

  if (top + tooltipCoords.height > window.innerHeight) {
    // не заезжать за нижний край окна
    tooltip.style.top =
      coords.top - WINDOW_PADDING - tooltipCoords.height + 'px';
  }
};
</script>
